module.exports = __webpack_public_path__ + "static/media/0001.5526d7b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0001.mp3
// module id = +L22
// module chunks = 0